enum GameVersion {
  basic,
  fancy,
}

export default GameVersion;
